<template>
  <div class="diamond">
    <div class="spotOrderList_head">
      <div class="orderNumber">
        <span>订单编号：</span>
        <span v-text="pieceData.orderNo"></span>
      </div>
      <div class="orderDate">
        <span>下单时间：</span><span v-text="pieceData.createdTime"></span>
      </div>
      <div class="upDownTopClass">
        <span>网点名称：</span><span v-text="pieceData.netAddress"></span>
      </div>
      <div class="network">
        <span>网点编码：</span>
        <span v-text="pieceData.netCode"></span>
      </div>
      <div
        v-if="+pieceData.orderStatus === 10 && pieceData.expiredTime"
        style="
              width: 200px;
              height: 32px;
              text-align: center;
              line-height: 32px;
              margin-left: 80px;
              color: rgb(236, 147, 104)"
      >
        请在{{ pieceData.expiredTime }}前完成支付
      </div>

      <div
        v-if="+pieceData.orderStatus === 50"
        style="color: #fff;
              width: 68px;
              height: 32px;
              text-align: center;
              line-height: 32px;
              background: #ec9368;
              cursor: pointer;
              border-radius: 2px;
              margin-left: 260px"
        @click="onConfirmReceive(pieceData.id, pieceData.orderNo)"
      >
        确认收货
      </div>
    </div>
    <div class="spotOrderList">
      <div>
        <div class="spotOrderList_body_data">
          <div
            class="spotOrderList_body_data_father"
            v-for="(val, i) in pieceData.detailList"
            :key="i"
            v-if="i < 3 || !pieceData.showNone"
          >
            <div class="spotOrderList_body_childTwo">
              <div
                v-if="pieceData.expressCompanyName"
                style="position: absolute; left: 546px; bottom: 32px;"
              >
                物流公司：{{ pieceData.expressCompanyName }}
              </div>
              <div
                v-if="pieceData.expressNo"
                style="position: absolute; left: 546px; bottom: 15px;"
              >
                物流单号：{{ pieceData.expressNo }}
              </div>

              <div class="goods">
                <div class="spotOrderList_body_img">
                  <img @click="enlargeImg(val)" :src="val.imgPath" alt="" />
                </div>
                <div class="orderStyleType">
                  <div class="bigClassName">{{ val.productName }}</div>
                  <div>款号：{{ val.styleNumber }}</div>

                  <div
                    class="spotBtn"
                    v-if="
                      pieceData.isSpot === '1' &&
                        pieceData.detailList[0].shopType === '2' &&
                        pieceData.isPresell !== '1'
                    "
                    @click="getSpot('素金', val)"
                  >
                    现货
                  </div>
                </div>
              </div>
              <div class="listChild orderSpecifications">
                <div class="specifications">
                  <div>
                    材质：<span>{{ val.texture }}</span>
                  </div>
                  <div>
                    品类：<span
                      >{{ val.productCategoryName
                      }}<span v-if="val.gender">-{{ val.gender }}</span></span
                    >
                  </div>
                  <div>
                    金重：<span v-if="pieceData.isSpot !== '1'">{{
                      val.goldWeigh
                    }}</span>
                  </div>
                  <div v-if="val.shopType == 3">
                    表盘颜色：<span v-if="pieceData.isSpot !== '1'">{{
                      val.dialColor
                    }}</span>
                  </div>
                  <div v-if="val.shopType == 3">
                    表带颜色：<span v-if="pieceData.isSpot !== '1'">{{
                      val.bandColor
                    }}</span>
                  </div>
                  <div>
                    规格：<span>{{ val.specifications || '' }}</span>
                  </div>
                </div>
                <div class="specifications">
                  <div v-if="val.shopType == 2">
                    计件加工费：<span v-if="pieceData.isSpot !== '1'">{{
                      val.pieceRateCost
                    }}</span>
                  </div>
                  <div v-if="val.shopType == 2 && hasPermission('网点店长')">
                    批发克工费：<span v-if="pieceData.isSpot !== '1'">{{
                      val.tradeWage
                    }}</span>
                  </div>
                  <div v-if="val.shopType == 2">
                    证书费：<span v-if="pieceData.isSpot !== '1'">{{
                      val.certificatePrice
                    }}</span>
                  </div>
                  <div>
                    是否未配齐货：<span
                      :class="{
                        'color-danger': val.isDistribution === '是',
                      }"
                      >{{ val.isDistribution }}</span
                    >
                  </div>
                  <div>
                    是否退货：<span
                      :class="{
                        'color-danger': val.isReturn === '是',
                      }"
                      >{{ val.isReturn }}</span
                    >
                  </div>
                  <div v-if="val.shopType == 3">
                    手表类型：<span v-if="pieceData.isSpot !== '1'">{{
                      val.mechanicalType
                    }}</span>
                  </div>
                  <div v-if="val.shopType == 3">
                    表带材质：<span v-if="pieceData.isSpot !== '1'">{{
                      val.bandMaterial
                    }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="orderLabel">
                {{ val.labelPrice }}
              </div> -->
              <!-- <div
                class="orderLabel"
                v-if="
                  !hasPermission('展厅') || !hasPermission('加盟公司总经理')
                "
              >
                {{ val.tradePrice }}
              </div> -->
              <div class="ordrerNumber">
                {{ pieceData.isSpot === '1' ? val.size : val.quantity }}
              </div>
              <div class="ordrerNumber">
                {{ val.actualQuantity }}
              </div>

              <div class="diamondRemarkClass">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="val.productRemark"
                  placement="bottom"
                >
                  <el-button>
                    <div class="spotOrderList_body_child_mainStone">
                      {{ val.productRemark }}
                    </div>
                  </el-button>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="orderAmount">
        <div v-if="+pieceData.isSpot !== 1">
          实际总件数：{{ pieceData.actualTotalQuantity }}
        </div>
        <div>下单总件数：{{ pieceData.totalQuantity }}</div>
        <!-- <div>标签总金额：{{ pieceData.totalLabelAmount }}</div> -->
        <!-- <div v-if="!hasPermission('展厅') || !hasPermission('加盟公司总经理')">
          批发总金额：{{ pieceData.totalTradeAmount }}
        </div> -->
        <div v-if="pieceData.detailList[0].shopType === '2'">
          现货素金总金重：{{ pieceData.totalGoldWeight }}
        </div>

        <template v-if="pieceData.supplierMobile">
          <div style="visibility: hidden;">占位</div>
          <div>
            供应商联系方式：
            <span class="color-danger">{{ pieceData.supplierMobile }}</span>
          </div>
        </template>

        <div>
          取货方式：
          <span class="color-danger">{{ pieceData.pictType }}</span>
        </div>
      </div>
      <div class="orderType">{{ pieceData.orderStatus | orderTypeFilter }}</div>
      <div class="spotOrderList_Tail orderReamrk">
        <div style="display:flex;align-items:center">
          <el-tooltip
            class="item"
            effect="dark"
            :content="pieceData.remark"
            placement="top"
          >
            <el-button>
              <div style="display: flex">
                <span style="display:block"></span
                ><span v-text="pieceData.remark" class="totalRemark"></span>
              </div>
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div
      class="toViewMore"
      v-if="pieceData.detailList.length > 3"
      @click="showHidden"
    >
      共有&nbsp;<span style="color:#ec9368">{{
        pieceData.detailList.length
      }}</span
      >&nbsp;种商品,<span v-if="pieceData.showNone"
        >还有&nbsp;{{ pieceData.detailList.length - 3 }}&nbsp;种,</span
      ><span v-if="pieceData.showNone">点击查看</span
      ><span v-if="!pieceData.showNone">点击收起</span>
    </div>
    <PlainGoldSpot
      v-if="plainGoldSpotDialogVisible"
      :plainGoldSpotDialogVisible="plainGoldSpotDialogVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      :modifyingReplication="modifyingReplication"
    />
  </div>
</template>
<script>
import PlainGoldSpot from './spot/PlainGoldSpot.vue'
import { orderTypeFilter } from '@/utils/filetrs'
import { confirmReceive } from '@/api/orderApi'

export default {
  name: 'PlainGold',
  props: {
    pieceData: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
      default() {
        return 0
      },
    },
  },
  components: {
    PlainGoldSpot,
  },
  filters: {
    orderTypeFilter,
  },
  data() {
    return {
      plainGoldSpotDialogVisible: false,
      modifyingReplication: {},
    }
  },
  mounted() {},
  methods: {
    onConfirmReceive(id, orderNo) {
      this.$confirm(`是否确定收货【${orderNo}】？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          confirmReceive({ id }).then((res) => {
            this.$message({
              message: res.msg || '收货成功',
              type: 'success',
              duration: 1500,
            })
            this.$parent.getOrderList()
          })
        })
        .catch(() => {})
    },

    // 订单跳转详情页
    enlargeImg(res) {
      if (res.shopType == '2') {
        this.$router.push({
          path: '/plaingold',
          query: {
            id: res.productId,
            generaName: res.productName,
            styleFlag: this.pieceData.isSpot === '1' ? '素金现货' : '素金定单',
          },
        })
      } else if (res.shopType == '3') {
        this.$router.push({
          path: '/watch',
          query: {
            id: res.productId,
            serialNumber: res.serialNumber,
            generaName: res.productName,
            styleFlag: this.pieceData.isSpot === '1' ? '手表现货' : '手表定单',
          },
        })
      }
    },
    // 获取现货列表
    getSpot(text, val) {
      if (text === '素金') {
        this.modifyingReplication = val
        this.plainGoldSpotDialogVisible = true
      }
    },
    onCloseSelectDialog() {
      this.plainGoldSpotDialogVisible = false
    },
    showHidden() {
      this.$emit('showHidden', this.index)
    },
  },
}
</script>

<style scoped lang="scss">
.diamond {
  .spotOrderList_head {
    display: flex;
    background: #fff2ea;
    line-height: 40px;
    border: 1px solid rgb(237, 226, 206);
    border-bottom: none;
    align-items: center;
    box-sizing: border-box;
    width: 1500px;

    .orderNumber {
      margin-left: 10px;
    }

    .orderDate {
      margin: 0 18px 0 10px;
    }

    .network {
      margin-right: 18px;
    }

    .upDownTopClass {
      margin-right: 18px;

      .dotName {
        display: flex;
        font-family: -webkit-body;

        .dotNameTitle {
          display: block;
        }

        .dotNameText {
          text-align: left;
          width: 300px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .el-button {
        width: 500px;
        background: #fff2ea;
        border: none;
        font-size: 16px;
        padding: 0;
        text-align: left;
        color: #000;
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .spotOrderList_body_img {
    margin-left: 10px;
    margin-top: 20px;

    img {
      width: 70px;
      height: 70px;
      box-sizing: border-box;
      cursor: pointer;
      border: 1px solid rgb(220, 223, 230);
    }
  }

  .spotOrderList_body_childTwo {
    position: relative;
    display: flex;
    padding: 15px 0;
    border-right: 1px solid rgb(220, 223, 230);
    border-bottom: 1px solid rgb(220, 223, 230);
  }

  .spotOrderList_body_data_father:last-child .spotOrderList_body_childTwo {
    border-bottom: none;
  }

  .spotOrderList {
    display: flex;
    align-items: center;
    border: 1px solid rgb(237, 226, 206);
    width: 1498px;
  }

  .spotOrderList_body_data {
    min-height: 110px;
    border-bottom: 1px solid rgb(237, 226, 206);
    position: relative;
  }

  .spotOrderList_body_data:last-child {
    border-bottom: none;
  }

  .spotOrderList_body_data_father {
    margin-left: 6px;
    font-size: 14px;
  }

  .goods {
    display: flex;
    width: 230px;
  }

  .orderStyleType {
    margin-left: 10px;
    margin-top: 20px;
  }

  .spotBtn {
    width: 100px;
    margin-top: 10px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    color: #ec9368;
    font-size: 14px;
    border: 1px solid #ec9368;
    border-radius: 5px;
    cursor: pointer;
  }

  .bigClassName:hover {
    color: red;
  }

  .bigClassName {
    width: 120px;
    white-space: pre-wrap;
  }

  .orderSpecifications {
    width: 200px;
    padding-right: 30px;
  }

  .orderLabel {
    width: 90px;
    margin-top: 7px;
  }

  .ordrerNumber {
    width: 80px;
    margin-top: 7px;
  }

  .orderReamrk {
    width: 140px;
  }

  .totalRemark {
    width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
  }

  .goodsRemark {
    width: 150px;
  }

  .orderAmount {
    width: 240px;
    margin-left: 20px;

    div {
      margin: 10px 0;
    }
  }

  .orderType {
    width: 80px;
  }

  .diamondRemarkClass {
    height: 34px;
    line-height: 34px;

    .el-button {
      background: #fff;
      border: none;
      font-size: 16px;
      padding: 0;
      text-align: center;
      color: #000;
      width: 150px;
      height: 34px;
      line-height: 34px;
    }
  }

  .spotOrderList_Tail .el-button {
    width: 150px;
    background: transparent;
    border: none;
    font-size: 16px;
    padding: 0;
    text-align: left;
    color: #000 !important;
    font-family: -webkit-body;
  }

  .spotOrderList_body_child_mainStone {
    min-width: 90px;
    color: #ec9368;
    width: 150px;
    margin-top: 2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
  }

  .toViewMore {
    text-align: center;
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    border: 1px solid rgb(237, 226, 206);
    border-top: none;
  }
}

.color-danger {
  color: #ed9970;
}
</style>
